export type StrataName = string

export type SiteFeature = { properties: { isRandomSite?: boolean; id?: string | number } }

export type MonitoringSitesBySamplingAreas = Record<StrataName, SiteFeature[]>

export type StrataFeature = { properties: { name: StrataName } }

export interface RandomizationPartition {
  toRandomize: StrataFeature[]
  locked: StrataFeature[]
}

// Un estrato se bloquea solo si tiene un sitio aleatorio YA GUARDADO (con id del backend). Los
// sitios recién aleatorizados sin guardar deben poder re-aleatorizarse hasta que se persista el plan.
export const computeStrataWithRandomSites = (
  monitoringSitesBySamplingAreas: MonitoringSitesBySamplingAreas,
): Set<StrataName> => {
  return new Set<StrataName>(
    Object.entries(monitoringSitesBySamplingAreas)
      .filter(
        ([, sites]) =>
          Array.isArray(sites) &&
          sites.some(site => site.properties.isRandomSite === true && Boolean(site.properties.id)),
      )
      .map(([strataName]) => strataName),
  )
}

export const computeLockedStrataNames = (
  disabledStrataNames: Set<StrataName>,
  strataWithRandomSites: Set<StrataName>,
): Set<StrataName> => {
  return new Set<StrataName>([...disabledStrataNames, ...strataWithRandomSites])
}

export const partitionStrataForRandomization = (
  strataFeatures: StrataFeature[],
  lockedStrataNames: Set<StrataName>,
): RandomizationPartition => {
  return {
    toRandomize: strataFeatures.filter(strata => !lockedStrataNames.has(strata.properties.name)),
    locked: strataFeatures.filter(strata => lockedStrataNames.has(strata.properties.name)),
  }
}
